export const filmCategories = [
  { id: "all", label: "全部影片" },
  { id: "class", label: "阶层欲望" },
  { id: "taboo", label: "禁忌情感" },
  { id: "court", label: "古装宫廷" },
  { id: "art", label: "文艺表达" },
];

export const films = [
  {
    id: "housemaid-2010",
    title: "下女",
    year: "2010",
    director: "林常树",
    cast: "全度妍、李政宰",
    category: "class",
    categoryLabel: "阶层欲望",
    tags: ["翻拍经典", "宅邸", "阶级"],
    summary:
      "一名年轻女佣走进豪门宅邸，欲望、猜忌与阶级在密闭空间里逐步失控。影片翻拍自金绮泳 1960 年的同名经典，用冷冽的镜头重讲同一则人性寓言。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20film%20poster%20style%2C%20elegant%20young%20woman%20in%20dark%20hanbok%20standing%20in%20a%20dim%20luxurious%20mansion%20corridor%2C%20warm%20amber%20lamp%20light%2C%20deep%20crimson%20tones%2C%20moody%20cinematic%20atmosphere%2C%20painterly%20texture%2C%20minimal%20composition%2C%20no%20text&width=600&height=900&seq=kfilm-cover-01&orientation=portrait",
  },
  {
    id: "handmaiden-2016",
    title: "小姐",
    year: "2016",
    director: "朴赞郁",
    cast: "金敏喜、金泰梨",
    category: "art",
    categoryLabel: "文艺表达",
    tags: ["反转叙事", "日据时期", "国际获奖"],
    summary:
      "日据时期的深宅里，一场精心设计的骗局与真心彼此缠绕。精致的构图、分章结构与层层反转，让这部作品成为近年最具国际影响力的韩国代表作之一。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20film%20poster%20style%2C%20two%20women%20in%201930s%20period%20dresses%20in%20a%20shadowy%20traditional%20estate%20garden%2C%20soft%20golden%20candlelight%2C%20deep%20red%20and%20ivory%20palette%2C%20refined%20cinematic%20illustration%2C%20mysterious%20mood%2C%20no%20text&width=600&height=900&seq=kfilm-cover-02&orientation=portrait",
  },
  {
    id: "eungyo-2012",
    title: "银娇",
    year: "2012",
    director: "郑址宇",
    cast: "朴海日、金高银",
    category: "taboo",
    categoryLabel: "禁忌情感",
    tags: ["创作", "迷恋", "衰老"],
    summary:
      "一位老诗人、他的学徒与一名少女之间，关于灵感、迷恋与衰老的细腻纠葛。影片没有评判，而是把欲望写成一种难以言说的创作冲动。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20film%20poster%20style%2C%20young%20woman%20by%20a%20sunlit%20window%20beside%20a%20wooden%20desk%2C%20aged%20paper%20tones%2C%20warm%20amber%20lighting%2C%20quiet%20melancholic%20atmosphere%2C%20painterly%20brush%20texture%2C%20no%20text&width=600&height=900&seq=kfilm-cover-03&orientation=portrait",
  },
  {
    id: "obsessed-2014",
    title: "人间中毒",
    year: "2014",
    director: "金大佑",
    cast: "宋承宪、林智妍",
    category: "taboo",
    categoryLabel: "禁忌情感",
    tags: ["军旅", "克制", "时代压抑"],
    summary:
      "军营与家庭之间，一段不被允许的情感悄然生长。影片以克制的节奏与大量留白，把个人欲望放进纪律森严的年代背景中对照。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20film%20poster%20style%2C%20silhouette%20of%20a%20soldier%20and%20a%20woman%20in%20a%20misty%20forest%20at%20dusk%2C%20muted%20olive%20and%20amber%20tones%2C%20restrained%20cinematic%20mood%2C%20painterly%20texture%2C%20no%20text&width=600&height=900&seq=kfilm-cover-04&orientation=portrait",
  },
  {
    id: "treacherous-2015",
    title: "奸臣",
    year: "2015",
    director: "闵奎东",
    cast: "朱智勋、金康宇",
    category: "court",
    categoryLabel: "古装宫廷",
    tags: ["朝鲜王朝", "权力", "阴谋"],
    summary:
      "以朝鲜王朝为舞台，把权力、欲望与阴谋编织成一张密不透风的网。华丽的服化道之上，是对朝堂黑暗与人心的冷静审视。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20film%20poster%20style%2C%20ornate%20Joseon%20palace%20hall%20with%20silhouettes%20behind%20silk%20screens%2C%20crimson%20drapery%20and%20gold%20accents%2C%20dramatic%20low%20light%2C%20painterly%20cinematic%20illustration%2C%20no%20text&width=600&height=900&seq=kfilm-cover-05&orientation=portrait",
  },
  {
    id: "frozen-flower-2008",
    title: "霜花店",
    year: "2008",
    director: "柳河",
    cast: "赵寅成、朱镇模",
    category: "court",
    categoryLabel: "古装宫廷",
    tags: ["高丽王室", "忠诚", "悲剧"],
    summary:
      "高丽王室的信任与背叛，把家国、忠诚与私情推向无法挽回的悲剧。影片以史诗般的调度，讲述一个关于选择与代价的宫廷故事。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20film%20poster%20style%2C%20royal%20figures%20in%20traditional%20robes%20inside%20a%20candlelit%20palace%20chamber%2C%20deep%20scarlet%20and%20bronze%20tones%2C%20dramatic%20chiaroscuro%2C%20painterly%20texture%2C%20no%20text&width=600&height=900&seq=kfilm-cover-06&orientation=portrait",
  },
  {
    id: "untold-scandal-2003",
    title: "丑闻",
    year: "2003",
    director: "李在容",
    cast: "裴勇俊、全度妍",
    category: "court",
    categoryLabel: "古装宫廷",
    tags: ["古典改编", "情欲博弈", "机智对白"],
    summary:
      "改编自法国小说《危险关系》，把风月博弈搬进十八世纪的朝鲜。优雅的画面与机锋对白之下，是情感算计与真心的角力。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20film%20poster%20style%2C%20eighteenth%20century%20Korean%20aristocrats%20in%20a%20garden%20pavilion%2C%20warm%20sepia%20and%20crimson%20palette%2C%20elegant%20painterly%20illustration%2C%20no%20text&width=600&height=900&seq=kfilm-cover-07&orientation=portrait",
  },
  {
    id: "portrait-of-a-beauty-2008",
    title: "美人图",
    year: "2008",
    director: "全闰秀",
    cast: "金敏善、金英浩",
    category: "art",
    categoryLabel: "文艺表达",
    tags: ["女画师", "身份", "艺术理想"],
    summary:
      "朝鲜时代一位女画师的自我追寻，在身份束缚与艺术理想之间反复挣扎。影片把画布、笔触与人物的命运交织在一起，气质清冷而诗意。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20film%20poster%20style%2C%20a%20female%20painter%20in%20traditional%20dress%20holding%20a%20brush%20before%20a%20scroll%2C%20soft%20amber%20sunlight%2C%20ink%20and%20paper%20texture%2C%20poetic%20calm%20mood%2C%20no%20text&width=600&height=900&seq=kfilm-cover-08&orientation=portrait",
  },
  {
    id: "virgin-stripped-2000",
    title: "处女心经",
    year: "2000",
    director: "洪常秀",
    cast: "李恩珠、文成根",
    category: "art",
    categoryLabel: "文艺表达",
    tags: ["结构叙事", "日常对话", "作者电影"],
    summary:
      "洪常秀标志性的结构叙事，用看似琐碎的日常对话，探讨情感里的选择、犹豫与不确定。是理解韩国作者电影的一把钥匙。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20film%20poster%20style%2C%20a%20couple%20walking%20on%20a%20quiet%20Seoul%20street%20in%20winter%2C%20muted%20warm%20tones%2C%20candid%20intimate%20mood%2C%20painterly%20film%20still%2C%20no%20text&width=600&height=900&seq=kfilm-cover-09&orientation=portrait",
  },
];